import { create } from 'zustand'

import { getUserReferralsApi } from '@api'

export interface UserReferralsItem {
  avatar_effect: string
  avatar_icon: string
  battlepass_level: number
  created_at: string
  first_name: string
  id: number
  is_premium: boolean
  last_name: string
  paid_battlepass: boolean
  passed_prologue: boolean
  photo_url: string
  skin_avatar_effect_id: string
  skin_avatar_item_id: string
  skin_spiral_item_id: string
  skin_stars_item_id: string
  username: string
}
export interface ItemDefData {
  item_def_id: string
  app_id: number
  name: string
  description: string
  type: string
  display_type: string
  price?: string
  icon_url: string
  tags?: string
  store_tags?: string
  store_hidden?: boolean
  game_only?: boolean
  supply?: number
  issued?: number
  bundle?: string
}

export interface UserReferralsRewardItem {
  is_available: boolean
  is_claimed: boolean
  is_claimable: boolean
  milestone_id: number
  referrals_count: number
  reward_meta: string[]
  reward_meta_extra?: number | string | null
  reward_type: string
  item_def_data?: Record<string, ItemDefData>
}

export interface ClaimRewardResponse {
  ok: boolean
  data: {
    description: string
    display_type: string
    icon_url: string
    item_id: string
    name: string
    quantity: number
  }
  error?: string | null
}

interface ReferralsFriendsStore {
  friends: UserReferralsItem[]
  rewards: UserReferralsRewardItem[]
  ratingForReferrals: number
  isLoading: boolean
  error: string | null
  actions: {
    fetchFriends: () => Promise<void>
  }
}

const useReferralsFriendsStore = create<ReferralsFriendsStore>((set) => ({
  friends: [],
  rewards: [],
  ratingForReferrals: 0,
  isLoading: false,
  error: null,
  actions: {
    fetchFriends: async () => {
      set({ isLoading: true })
      const { data, ok } = await getUserReferralsApi()
      if (ok && data) {
        set({
          friends: data.referrals,
          rewards: data.rewards,
          ratingForReferrals: data.rating_for_referrals,
        })
      }
      set({ isLoading: false })
    },
  },
}))

export const useReferralsFriendsActions = () =>
  useReferralsFriendsStore((state) => state.actions)
export const useReferralsStore = () =>
  useReferralsFriendsStore((state) => ({
    friends: state.friends,
    rewards: state.rewards,
    ratingForReferrals: state.ratingForReferrals,
    isLoading: state.isLoading,
  }))
